import * as types from '../mutation-types'
const state = {
    orders: []
}
const actions = {
    createOrder(_, {orderType, doc_no, external_account_id, date, notes}) {
        return window.axios.post(`/MaterialFlow/Order/${orderType}`, {
            doc_no: doc_no,
            external_account_id: external_account_id,
            date: date,
            notes: notes
        }).then((response) => response)
    },
    updateOrder(_, {orderType, id, doc_no, external_account_id, date ,notes}) {
        return window.axios.put(`/MaterialFlow/Order/${orderType}/${id}`, {
            doc_no: doc_no,
            external_account_id: external_account_id,
            date: date,
            notes: notes
        }).then((response) => response);
    },
    changeOrderStatus(_, {orderType, id, status}) {
        return window.axios.put(`/MaterialFlow/Order/${orderType}/${id}/Status`, status, {
            headers: {'Content-Type': 'application/json'}
        }).then((response) => response);
    },
    fetchOrders({ commit }, orderType) {
        return window.axios.get(`/MaterialFlow/Order/${orderType}`).then(({data}) => {
            commit(types.STORE_ORDERS, data);
            return data;
        })
    },
    fetchOrder(_, {id, orderType}) {
        return window.axios.get(`/MaterialFlow/Order/${orderType}/${id}`).then(({data}) => {
            return data;
        })
    },
    deleteOrder(_, {id, orderType}) {
        return window.axios.delete(`/MaterialFlow/Order/${orderType}/${id}`).then(response => response)
    },
    createEntry(_, {entry, id, orderType}) {
        return window.axios.post(`/MaterialFlow/OrderEntries/${orderType}/${id}/Entries`, entry).then(response => response)
    },
    updateEntry(_, {entry, id, orderType, entryId}) {
        return window.axios.put(`/MaterialFlow/OrderEntries/${orderType}/${id}/Entries/${entryId}`, entry).then(response =>  response)
    },
    deleteEntry(_, {id, entryId, orderType}) {
        return window.axios.delete(`/MaterialFlow/OrderEntries/${orderType}/${id}/Entries/${entryId}`).then(response => response)
    },
    createInvoice(_, {invoiceType, order_id, invoice}) {
        return window.axios.post(`/MaterialFlow/Order/${invoiceType}/${order_id}/InvoiceRequest`, invoice).then(({data}) => data)
    }
}
const mutations = {
    [types.STORE_ORDERS] (state, data) {
        state.orders = data;
    }
}
const getters = {
    getOrderByNo : state => no => state.orders.find(c => c.no === no)
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}